module.exports = __webpack_public_path__ + "img/part5-4.30e779ed.png";